import type { FC, ReactElement } from "react";

import { StyledTooltip } from "~/components/UI/StyledTooltip";

import * as Styled from "./PremiumFeatureTooltip.styles";

const TOOLTIP_TITLE = "Premium feature";
const UPGRADE_ACTION_TEXT = "Upgrade now";

interface IPremiumFeatureTooltipProps {
  description: string;
  pricingUrl: string;
  children: ReactElement;
}

export const PremiumFeatureTooltip: FC<IPremiumFeatureTooltipProps> = ({
  description,
  pricingUrl,
  children,
}) => {
  const content = (
    <Styled.Content>
      <Styled.Header>
        <Styled.TrophyIcon />
        <Styled.Title variant="caption">{TOOLTIP_TITLE}</Styled.Title>
      </Styled.Header>
      <Styled.Description variant="caption">{description}</Styled.Description>
      <Styled.UpgradeLink
        to={pricingUrl}
        onMouseDown={(e) => e.preventDefault()}
      >
        {UPGRADE_ACTION_TEXT}
      </Styled.UpgradeLink>
    </Styled.Content>
  );

  return (
    <StyledTooltip
      title={content}
      maxWidth={260}
      arrow
      enterTouchDelay={0}
      leaveTouchDelay={3000}
    >
      {children}
    </StyledTooltip>
  );
};
